import React from 'react';
import {removeLeadingAndTrailingQuotations} from "../../../../../utils/string";
import ReactToolTip from 'react-tooltip';
import {PRIORITY_HIGH, PRIORITY_LOW, PRIORITY_MEDIUM} from "../../../../recording/utils";

const TOOLTIP_HIGH_ID = "priorityHighTip";
const TOOLTIP_MEDIUM_ID = "priorityMediumTip";
const TOOLTIP_LOW_ID = "priorityLowTip";
const TOOLTIP_NONE_ID = "priorityNoneTip";

const STYLE_RECORDING_CARD_PRIORITY = {
    float: 'left'
};

/**
 * A component that is displayed for a high priority recording card
 */
const HighPriority = () => {
    return (
        <div style={STYLE_RECORDING_CARD_PRIORITY}>
            <div data-tip data-for={TOOLTIP_HIGH_ID} style={{color: 'red'}}>
                <i className="fas fa-exclamation-circle" /> High Level Event
            </div>
            <ReactToolTip id={TOOLTIP_HIGH_ID} type="error">
                <span>The recording was automatically uploaded after a strong impact.</span>
            </ReactToolTip>
        </div>
    );
};

/**
 * A component that is displayed for a medium priority recording card
 */
const MediumPriority = () => {
    return (
        <div style={STYLE_RECORDING_CARD_PRIORITY}>
            <div data-tip data-for={TOOLTIP_MEDIUM_ID} style={{color: 'orange'}}>
                <i className="fas fa-exclamation-circle" /> Medium Level Event
            </div>
            <ReactToolTip id={TOOLTIP_MEDIUM_ID} type="warning">
                <span>The recording was automatically uploaded after a medium impact.</span>
            </ReactToolTip>
        </div>
    );
};

/**
 * A component that is displayed for a low priority recording card
 */
const LowPriority = () => {
    return (
        <div style={STYLE_RECORDING_CARD_PRIORITY}>
            <div data-tip data-for={TOOLTIP_LOW_ID} style={{color: 'midnightblue'}}>
                <i className="fas fa-exclamation-circle" /> Low Level Event
            </div>
            <ReactToolTip id={TOOLTIP_LOW_ID} type="info">
                <span>The recording was automatically uploaded after a low impact.</span>
            </ReactToolTip>
        </div>
    );
};

/**
 * A component that is displayed for a none priority recording card
 */
const NonePriority = () => {
    return (
        <div style={STYLE_RECORDING_CARD_PRIORITY}>
            <div data-tip data-for={TOOLTIP_NONE_ID}>
                <i className="fas fa-video" /> User Recording
            </div>
            <ReactToolTip id={TOOLTIP_NONE_ID}>
                <span>The recording was manually uploaded.</span>
            </ReactToolTip>
        </div>
    );
};

/**
 * A component returns the appropriate component
 * depending on the priority level {@code rawPriority}.
 */
const PriorityLevel = ({rawPriority}) => {
    if (rawPriority) {
        const priority = removeLeadingAndTrailingQuotations(rawPriority);
        if (priority === PRIORITY_HIGH) {
            return <HighPriority/>;
        } else if (priority === PRIORITY_MEDIUM) {
            return <MediumPriority/>;
        } else if (priority === PRIORITY_LOW) {
            return <LowPriority/>;
        }
    }
    return <NonePriority/>;
};

export default PriorityLevel;



// WEBPACK FOOTER //
// ./src/components/unit/recordings/recordingcard/information/PriorityLevels.jsx